import { Outlet } from "react-router-dom";

function ProductLayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default ProductLayout;
